import { Modal } from 'bootstrap';
import { Invoice } from 'shared/classes/Billing';
import { setDataAndShowDetailsModal } from 'static/components/details-modal/details-modal';

export function AllPayinsViewModel(data){

    //console.log(data);

    var self = this;
    self.type = "AllPayinsViewModel";

    self.rootvm = data.rootvm;

    self.initialized = ko.observable(false);
    self.initialize = function(){

       // console.log('initing all past_events vm');

        if (!self.initialized()){
            self.lookup_payins();
        }

        if (self.offset() == undefined){
            self.offset(0);
        }
        if (self.limit() == undefined){
            self.limit(30);
        }
    };

    self.total_count = ko.observable();
    self.filtered_count = ko.observable();
    self.offset = ko.observable();
    self.limit = ko.observable(30);
    self.payin_status = ko.observable();
    self.payin_tag = ko.observable();

    self.invoices = ko.observableArray([]);

    self.error = ko.observable();
    self.search_name = ko.observable();
    self.only_past_due = ko.observable(false);

    self.search_name_click = function(){
        self.offset(0);
        console.log('searching with ', self.search_name());
        self.lookup_payins();
        return false;
    }


    self.lookup_payins = function(){
        self.rootvm.is_busy(true);
        return $.ajax({

            url: self.rootvm.web_host + '/api/admin/payins',
            type: 'GET',
            data:{
                limit: self.limit() || 30,
                offset: self.offset(),
                search_name: self.search_name(),
                only_past_due : self.only_past_due(),
                payin_status : self.payin_status(),
                payin_tag: self.payin_tag()
            },

            contentType: "application/json; charset=utf-8",

            success: function (data) {

                self.invoices(ko.utils.arrayMap( data.invoices || [],
                    function(x){
                        const inv = x.invoice;
                        inv.rootvm = self.rootvm
                        //inv.payin = new Payin(x.payin);
                        inv.payin = x.payin;
                        return new Invoice(inv);
                    }));

                self.total_count(data.total_count);
                self.filtered_count(data.total_count);

            },
            error: function (data) {
                notyf.error(data.statusText);
            },
            complete: function(){
                self.rootvm.is_busy(false);
            }
        });
    };


    self.set_selected_data = (invoice, tabId) => {
        let data = null;
        if (tabId === 'host') {
            data = invoice.receiver()
        } else if (tabId === 'artist') {
            data = invoice.sender()
        } else {
            throw new Error(`Invaild tabId: ${tabId}`);
        }
        setDataAndShowDetailsModal(data, tabId)
    }

    // Payin Tag Modal
    self.selected_invoice = ko.observable();
    self.new_payin_tag = ko.observable();

    self.open_payin_modal = (invoice) => {
        self.selected_invoice(invoice);
        self.new_payin_tag(undefined);
        const payinTagModal = document.getElementById('payinTagModal');
        Modal.getOrCreateInstance(payinTagModal).show();
    }

    self.add_payin_tag = () => {
        console.log('adding payin tag');
        self.selected_invoice().payin().add_payin_tag(self.new_payin_tag());

    }
    self.remove_payin_tag = (invoice)  => {
        console.log('removing payin tag');
        invoice.payin().remove_payin_tag();

    }
    // Everything below is for paging -- should really create a
    // component at some point

    self.lower_count_label = ko.computed(function(){
        return parseInt(self.offset()) + 1;
    });

    self.upper_count_label = ko.computed(function(){
        if (parseInt(self.limit()) + parseInt(self.offset()) > self.filtered_count())
        {
            return self.filtered_count();
        }
        else
        {
            return parseInt(self.limit()) + parseInt(self.offset());
        }
    });



    self.paging_visible = ko.computed(function () {
        return self.total_count() > 0;
    });

    self.next_button_visible = ko.computed(function() {
        return parseInt(self.offset()) + parseInt(self.limit()) < self.filtered_count();
    });

    self.previous_button_visible = ko.computed(function () {
        return parseInt(self.offset()) > 0;
    });



    self.go_left = function () {

        if (self.rootvm.is_busy()){
            return false;}

        self.offset(parseInt(self.offset()) - parseInt(self.limit()));

        self.lookup_payins().then(function(){
            pager.navigate("#concerts/payins"
                + "?offset="
                + self.offset()
                + "&limit="
                + self.limit()
            );
        });
    };

    self.go_right = function () {

        if (self.rootvm.is_busy()){
            return false;}

        self.offset(parseInt(self.offset()) + parseInt(self.limit()));
        self.lookup_payins().then(function(){
            pager.navigate("#concerts/payins"
                + "?offset="
                + self.offset()
                + "&limit="
                + self.limit()
            );
           });
    };
};
